import { render } from "./KinderFeuer.vue?vue&type=template&id=ec6a354c&scoped=true"
import script from "./KinderFeuer.vue?vue&type=script&lang=js"
export * from "./KinderFeuer.vue?vue&type=script&lang=js"

import "./KinderFeuer.vue?vue&type=style&index=0&id=ec6a354c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Florian\\Desktop\\FeuerwehrWeb3\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec6a354c"]])

export default __exports__